import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LanguageStore } from '../stores/LanguageStore';
import { de } from '../translations/de';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  private readonly _store = inject(LanguageStore);

  public loadLanguage(): Observable<void> {
    this._store.language.set({ code: 'de', name: 'Deutsch' });
    this._store.dictionary.set(de);
    return of(void 0);
  }
}
